<!-- [ariaLabel] repeats the drawn label. cs-bar-button now names its inner <button> from its
     drawn text by itself, so these are no longer needed; they are harmless and left in place.
     #4142: text-only buttons (mock boards H/J). The exercise menu moved to the card header's top
     right, and "Add Note" took its place; it is shown only while the exercise has no pinned note. -->
<cs-bar-button compact [label]="LL.workouts.buttons.instructions()"
  [ariaLabel]="LL.workouts.buttons.instructions()"
  (click)="onInstructionsClick($event)"></cs-bar-button>
<cs-bar-button compact [label]="LL.workouts.buttons.history()"
  [ariaLabel]="LL.workouts.buttons.history()"
  (click)="onHistoryClick($event)"></cs-bar-button>
@if (showAddNote) {
  <cs-button class="add-note" tertiary small (click)="onAddNoteClick($event)">
    {{ LL.workouts.buttons.addNote() }}
  </cs-button>
}
